<template>
    <div class="az-loading">
        <v-dialog
            v-model="isLoading"
            persistent
            width="300"
        >
            <v-card
                color="white"
                dark
                width="300"
            >
                <v-card-text class="black--text">
                    {{ loadingMessage }}
                    <v-progress-linear
                            indeterminate
                            color="primary"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'LocalLoading',
    computed: {
        isLoading() {
            return this.$store.state.loadingLocal.exibir
        },
        loadingMessage() {
            return this.$store.state.loadingLocal.mensagem
        }
    }
}
</script>
